export default __webpack_public_path__ + "static/media/pinterest_short_600x900px.92372bb2.png";